module.exports = __webpack_public_path__ + "static/img/bg-tit2.8423f7cf.webp";